import classNames from "./DefaultVoiceAvatarSetting.module.css";
import { useState } from "react";
import { Setting } from "./Settings";
import useUser from "../../../../hooks/user";
import VoiceAvatar from "../../../common/dialogs/voice/VoiceAvatar";
import { Voice } from "../../../../types";
import { useSelectedVoice } from "../../../../hooks/voice";
import { Organization } from "../../../../hooks/api";

export default function DefaultVoiceAvatar(props: {
  organization: Organization;
  onChange: (organization: Organization) => void;
}) {
  const [user] = useUser();
  const initialVoice = useSelectedVoice(
    user.metadata.selectedLanguage,
    props.organization.default_avatar_setting
  );
  const [voice, setVoice] = useState<Voice | undefined>(initialVoice);

  return (
    <Setting
      title="Voice avatars"
      subtitle="Please select your voice avatars"
      className={classNames.DefaultVoiceAvatarSetting}
    >
      <>
        <VoiceAvatar
          basic={!props.organization.voice_avatar_enabled}
          selectedVoice={voice}
          onSelectVoice={(voice) => {
            setVoice(voice);
            props.onChange({
              ...props.organization,
              default_avatar_setting: voice.id,
            });
          }}
        />
      </>
    </Setting>
  );
}
